// extracted by css-extract-rspack-plugin
export default {"cls1":"SimplePaperPodcast-cls1_xVz","cls2":"SimplePaperPodcast-cls2_1pi SimplePaperPodcast-cls1_xVz"};